/*
 * @Description:
 * @Autor: lwq
 * @Date: 2020-07-22 16:16:42
 * @最后编辑: Betway
 * @最后修改时间: 2022-04-27 10:19:55
 * @FilePath: \mrc-base-frontend\src\mixin\national.js
 */
import { getNationFields } from "@/service/api/internationalization";
export default {
  data() {
    return {
      national_fields: [],
      national_fields1: [],
      national_fields2: [],
      national_fields3: [],
    };
  },
  methods: {
    async national(table_names, national_fields = "national_fields") {
      const res = await getNationFields({
        org_level_uuid: this.$store.state.userData.org_level_uuid,
        table_names,
      });
      if (res.code == 200) {
        this[national_fields] = res.data.Data;
      }
    },
    judegNational(field, national_fields = "national_fields") {
      return this[national_fields].includes(field);
    },
    // 处理国际化字段函数
    INT(arr) {
      if (!arr && arr !== 0) return;
      const type = Object.prototype.toString.call(arr);
      if (type.indexOf("Array") <= -1) {
        return arr;
      }
      let newArr = [];
      if (arr.length <= 0) {
        return "";
      }
      const map = new Map();
      arr.forEach((item) => {
        for (let i in item) {
          map.set(i, item[i]);
        }
      });
      // console.log(arr, arr.length);
      // console.log(map, 'map', map.length);
      // console.log(this.$store.state.lang === "zh-CN");
      // console.log(map.get('en'));
      // console.log(map.get('zh-CN'));
      // console.log(map.get('zh-HK'));
      // console.log(map.get(this.$store.state.lang));
      // console.log(arr,map,this.$store.state.lang,'---------',map.get(this.$store.state.lang));
      return map.get(this.$store.state.lang);

      // arr.forEach((item, index) => {
      //         newArr.push({})
      //         for (let i in item) {
      //             if (item[i] && i != 'uuid' && i != 'language_code') {
      //                 newArr[index][i] = item[i]
      //             }
      //         }
      //     })
      //     // console.log(newArr);
      // const keys = newArr.map(item => {
      //     return Object.keys(item)[0]
      // })

      // const values = newArr.map(item => {
      //     return Object.values(item)[0]
      // })
      // const currentLanguageIndex = keys.findIndex(item => item == this.$store.state.lang)
      // return values[currentLanguageIndex]
    },
    // 处理列表参照返回的国际化格式
    splitINT(arr) {
      if (!arr) {
        return [];
      }
      const type = Object.prototype.toString.call(arr);
      // 字符串
      if (type.indexOf("String") > -1) {
        if (arr) {
          arr = arr.indexOf(",") > -1 ? arr.split(",") : [arr];
        } else arr = [];
        return arr;
      } else if (type.indexOf("Array") > -1) {
        if (arr.length <= 0) {
          return [];
        }
        // 数组
        let list = [];
        arr.forEach((item) => {
          if (this.$store.state.lang == item.language_code) {
            list = item[item.language_code].split(",");
          }
        });
        return list;
      } else {
        // 其他
        return [];
      }
    },
  },
};
